import React from "react";
import PropTypes from "prop-types";
import "./Tweet.css";

//Unpacking props (preferred method)
function Tweet({ author, message, followers }) {
  return (
    <div className="tweet">
      <h1 className="author">{author}</h1>
      <h1 className="message">{message}</h1>
      <h1 className="followers">Followers: {followers}</h1>
    </div>
  );
}

// //Another way of using props
// function Tweet(props) {
//   return (
//     <div className="tweet">
//       <h1 className="author">{props.author}</h1>
//       <h1 className="message">{props.message}</h1>
//       <h1 className="followers">{props.followers}</h1>
//     </div>
//   );
// }

//Setting default props in case user does not pass a prop in the component
Tweet.defaultProps = {
  author: "Jack",
  message: "Hey There!",
  followers: 0,
};

//Setting propTypes for a robust code to catch errors
Tweet.propTypes = {
  author: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  followers: PropTypes.number.isRequired,
};

export default Tweet;
